import axios from 'axios';

const CONFLICT_TYPES = Object.freeze({
  CONFLICT_ON_SAME_SCENARIO: 'conflict_on_same_scenario',
  CONFLICT_ON_COMPATIBLE_SCENARIOS: 'conflict_on_compatible_scenarios'
})

const CONFLICT_STATUSES = Object.freeze({
  RESOLVED: 'resolved',
  UNRESOLVED: 'unresolved',
  WORK_IN_PROGRESS: 'work_in_progress'
})

export const CONFLICT_RESOLUTION_STEPS = Object.freeze({
  SELECT_CONFLICT: 'select_conflict',
  CHOOSE_RESOLUTION_MODE: 'choose_resolution_mode',
  CHALLENGE_PREFERENCE: 'challenge_preference',
  CHOOSE_BY_ADDING_INFORMATION: 'choose_by_adding_information',
  CHOOSE_BY_ADDING_INFORMATION_WITH_GROUPS: 'choose_by_adding_information_with_groups',
  CHOOSE_EXCLUSIVE_AND_UNIQUE_WIGO: 'choose_exclusive_and_unique_wigo',
  CONFIRM_POSSIBLE_SCENARIO: 'confirm_possible_scenario',
  MAKE_GROUPS: 'make_groups',
})

export const POSSIBLE_ANSWSERS = Object.freeze({
  YES_EXCLUSIVE_AND_UNIQUE: CONFLICT_RESOLUTION_STEPS.CHOOSE_EXCLUSIVE_AND_UNIQUE_WIGO,
  NO_BUT_I_CAN_CHOOSE_BY_ADDING_INFORMATION: CONFLICT_RESOLUTION_STEPS.CHOOSE_BY_ADDING_INFORMATION,
  NO_I_PREFER_MAKING_GROUPS: 'no_i_prefer_making_groups',
  NO_I_CAN_NOT_DECIDE: 'no_i_can_not_decide'
})

export default {

  getConflicts(projectId, page, pageSize) {
    console.log('getConflicts', projectId)
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/conflicts?pageSize=${pageSize}&page=${page - 1}`)
  },

  getConflict(projectId, conflictId) {
    console.log('getConflict', projectId, conflictId)
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/conflicts/${conflictId}`)
  },

  prefer(projectId, conflictId, preferredChoice) {
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/conflicts/${conflictId}`,
      preferredChoice);
  },

  clearResolution(projectId, conflictId) {
    return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/conflicts/${conflictId}`);
  },

  resume(projectId, conflictId) {
    console.log('resume', projectId, conflictId)
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/conflicts/${conflictId}/resume`)
  },

  isConflictResolved(conflict) {
    return conflict.status === CONFLICT_STATUSES.RESOLVED
  },

  hasConflictWorkInProgress(conflict) {
    return conflict.status === CONFLICT_STATUSES.WORK_IN_PROGRESS
  },

  isConflictOnSameScenario(conflict) {
    return conflict.type === CONFLICT_TYPES.CONFLICT_ON_SAME_SCENARIO
  },

  isChooseResolutionMode(step) {
    return step === CONFLICT_RESOLUTION_STEPS.CHOOSE_RESOLUTION_MODE
  },

  isChooseExclusiveAndUniqueWigo(step) {
    return step === CONFLICT_RESOLUTION_STEPS.CHOOSE_EXCLUSIVE_AND_UNIQUE_WIGO
  },

  isChallengePreference(step) {
    return step === CONFLICT_RESOLUTION_STEPS.CHALLENGE_PREFERENCE
  },

  isSelectConflict(step) {
    return step === CONFLICT_RESOLUTION_STEPS.SELECT_CONFLICT
  },

  isChooseByAddingInformation(step) {
    return step === CONFLICT_RESOLUTION_STEPS.CHOOSE_BY_ADDING_INFORMATION
  },

  isChooseByAddingInformationWithGroups(step) {
    return step === CONFLICT_RESOLUTION_STEPS.CHOOSE_BY_ADDING_INFORMATION_WITH_GROUPS
  },

  isConfirmPossibleScenariosUnion(step) {
    return step === CONFLICT_RESOLUTION_STEPS.CONFIRM_POSSIBLE_SCENARIO
  },

  isMakeGroups(step) {
    return step === CONFLICT_RESOLUTION_STEPS.MAKE_GROUPS
  }
}